import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useNewWebsite } from "context/client/new_website";

import DetailsCard from "components/DetailsCard";
import FormikInput from "components/formik/FormikInput";
import Button from "components/Button";
import { Info } from "./components";

import useResponsive from "libs/helpers/useResponsive";
import domainSchema from "libs/validations/new_website_form/domainSchema";

const mainClass = "new-website-content__domain";

const Domain = () => {
  const { t } = useTranslation();
  const { max, min } = useResponsive();

  const { website, change_plan_mode, form_data, nextStep } = useNewWebsite();

  const onSubmit = (values) => {
    nextStep(values);
  };

  return (
    <Formik
      initialValues={{
        website: !!change_plan_mode
          ? website?.website
          : form_data?.website || "",
      }}
      validationSchema={domainSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values, setSubmitting);
      }}
    >
      {({ isSubmitting }) => (
        <Form className={mainClass} autoComplete="off">
          <div className={`${mainClass}__column`}>
            <DetailsCard title={t("Website address")} largeHeaderMobileText>
              <FormikInput
                name="website"
                label={t("Domain")}
                placeholder="example.com"
                disabled={isSubmitting || !!change_plan_mode}
                required
              />
              <div className={`${mainClass}__cta`}>
                <Button type="submit">
                  {t(max.lg ? "Next step [ALT]" : "Next")}
                </Button>
              </div>
            </DetailsCard>
          </div>
          {min.sm && (
            <div className={`${mainClass}__column`}>
              <Info change_plan_mode={change_plan_mode} />
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};

Domain.Info = Info;

export default Domain;
